import { ErrorState } from "@/features/devices/components/ErrorState";

/** Falha de asset pode ser troca de release ou rede; nunca afirmar qual sem prova. */
function isAssetLoadFailure(message: string): boolean {
  return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|unable to preload css|loading (?:css )?chunk .+ failed/i.test(message);
}

export function NavigationErrorState({ error, onReload }: { error: unknown; onReload: () => void }) {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "Erro inesperado";
  const assetFailure = isAssetLoadFailure(message);
  return <div className="app"><main className="main"><div className="content">
    <ErrorState
      title={assetFailure ? "Não foi possível carregar esta tela" : "Algo quebrou na navegação"}
      message={assetFailure
        ? "A conexão pode ter falhado ou uma nova versão do sistema pode estar disponível. Recarregue a página para tentar novamente."
        : message}
      onRetry={onReload}
      retryLabel="Recarregar página"
    />
    <p>O recarregamento é manual. Alterações locais não salvas podem ser perdidas.</p>
  </div></main></div>;
}
